export default __webpack_public_path__ + "2a8cedc.svg";